import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { ArrowRight, CheckCircle, Clock, Award } from 'lucide-react';
import { sendButtonClickEvent, sendScrollToTopEvent } from '../../utils/postMessageBridge';
import ModalContactForm from '../forms/ModalContactForm';


const FinalCTASection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formModalOpen, setFormModalOpen] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.getElementById('final-cta');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  const openFormModal = () => {
    sendButtonClickEvent('FINAL_CTA_BERATUNGSTERMIN', {
      section: 'final-cta',
      action: 'open-modal'
    });
    
    // Mobile: Sofort öffnen
    const isMobile = window.innerWidth < 768;
    
    if (isMobile) {
      setFormModalOpen(true);
    } else {
      // Desktop: Scroll nach oben, dann Modal öffnen
      sendScrollToTopEvent();
      try {
        window.parent.postMessage({ type: 'SCROLL_TO_TOP' }, '*');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (e) {
        console.log('PostMessage failed:', e);
      }
      
      setTimeout(() => {
        setFormModalOpen(true);
      }, 400);
    }
  };

  return (
    <section id="final-cta" className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-96 h-96 rounded-full" 
             style={{backgroundColor: '#91d33d', filter: 'blur(80px)'}}></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 rounded-full" 
             style={{backgroundColor: '#57c558', filter: 'blur(80px)'}}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className={`text-center max-w-4xl mx-auto transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 relative z-50">
            <span className="text-gray-300">In 1 Minute zum Angebot – </span>
            <span className="relative z-50">
              <span className="bg-gradient-to-r from-brand-green to-brand-green-light bg-clip-text text-transparent">
                vom Qualitätsführer in Berlin & Brandenburg
              </span>
            </span>
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-12 mt-12">
            {[
              {
                icon: CheckCircle,
                title: "100% kostenlos",
                description: "Unverbindliche Beratung"
              },
              {
                icon: Clock,
                title: "24h Antwort",
                description: "Schnelle Rückmeldung garantiert"
              },
              {
                icon: Award,
                title: "Meisterbetrieb",
                description: "13+ Jahre Erfahrung"
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-sm p-6 rounded-2xl border border-white/10">
                <feature.icon className="w-12 h-12 text-brand-green mx-auto mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-400">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <Button
            onClick={openFormModal}
            size="lg"
            className="bg-brand-orange hover:bg-brand-orange-hover text-white px-12 py-7 text-xl shadow-2xl hover:shadow-brand-orange/50 transition-all duration-300 group"
          >
            <span>Beratungstermin</span>
            <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" />
          </Button>

          <p className="text-gray-400 mt-8 text-lg">
            Über 2.000 zufriedene Kunden aus Berlin & Brandenburg vertrauen bereits auf unsere Expertise. 
            Werden Sie Teil der Energiewende und profitieren Sie von bis zu <span className="text-brand-green font-semibold">70% staatlicher Förderung</span>.
          </p>
        </div>
      </div>
      
      <ModalContactForm 
        isOpen={formModalOpen} 
        onClose={() => setFormModalOpen(false)} 
      />
    </section>
  );
};

export default FinalCTASection;